export const ROUTES = {
  LOGIN: "/",
  FORGOT_PASSWORD: "/forgotPassword",
  PROFILE: "/profile",
  ORGANISATIONS: "/organisations",
  FLEETS: "/fleets",
  VEHICLE: "/vehicles",
  VEHICLE_PARTS: "/vehicle/parts",
  VEHICLE_MODEL: "/vehicleModel",
  PART_MODEL: "/partModel",
  SUBSCRIPTION: "/subscriptions",
  LOGOUT: "/logout",
  CONFIRM_REGISTRATION: "/registrationConfirm",
};

export const HEADERS = {
  LOGIN: "Login to your account",
  FORGOT_PASSWORD: "Forgot Password?",
  PROFILE: "Profile",
  LOGOUT: "Logout",
};

export const FOOTER = {
  PREFIX_TEXT: "Grafana Admin ©",
  SUFFIX_TEXT: "Created by NicheSolv",
};

export const BUTTONS = {
  MAP_IT: "Map It",
  SAVE: "Save",
  ADD_NEW: "Add New",
  CREATE: "Create",
  MODIFY: "Modify",
  NO: "No",
  YES: "Yes",
  SUBSCRIBE: "Subscribe",
  REPUBLISH: "Republish",
  REPUBLISH_ALL: "Republish All",
};

export const STATUS_TYPE = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const ORGANISATION_TYPE = {
  ADMINISTRATOR: "ADMINISTRATOR",
  MANUFACTURER: "MANUFACTURER",
  DEALER: "DEALER",
  B2BCUSTOMER: "B2BCUSTOMER",
  B2CCUSTOMER: "B2CCUSTOMER",
};

export const FORMS = {
  PROFILE: {
    NAME: "Name",
    EMAIL: "Email",
    ORGANISATION: "Organisation",
    ROLE: "Role",
    PHONE_NUMBER: "Phone Number",
  },
  ORGANISATIONS: {
    HEADER: "Create Organisation",
    FIELDS: {
      NAME: { LABEL: "Name", NAME: "name" },
      EMAIL: { LABEL: "Email", NAME: "email" },
      PHONE_NUMBER: { LABEL: "Phone Number", NAME: "phoneNumber" },
      DESCRIPTION: { LABEL: "Description", NAME: "description" },
      ADDRESS1: { LABEL: "Address1", NAME: "address1" },
      ADDRESS2: { LABEL: "Address2", NAME: "address2" },
      CITY: { LABEL: "City", NAME: "city" },
      ADMIN_AREA: { LABEL: "Admin Area", NAME: "adminArea" },
      POSTAL_CODE: { LABEL: "Postal Code", NAME: "postalCode" },
      COUNTRY: { LABEL: "Country", NAME: "country" },
      LINK_ORGANISATION_ID: {
        LABEL: "Link Organisation Id",
        NAME: "linkOrganisationId",
        PLACEHOLDER: "Link Organisation",
      },
      ORGANISATION_TYPE: {
        LABEL: "Organisation Type",
        NAME: "organisationType",
        PLACEHOLDER: "Select Organisation Type",
      },
      IS_COMMERCIAL: { LABEL: "Is Commercial", NAME: "isCommercial" },
      URL_SLUG: { LABEL: "Url Slug", NAME: "urlSlug" },
      IS_LOGIN_ENABLED: {
        LABEL: "Is Login Enabled?",
        NAME: "isLoginEnabled",
      },
    },
    FIELDSB2CCUSTOMER: {
      FIRSTNAME: { LABEL: "FirstName", NAME: "fname" },
      LASTNAME: { LABEL: "LastName", NAME: "lname" },
    },
  },
  ORGANISATION_SUBSCRIPTION: {
    HEADER: "Organisation Subscription Plan",
    FIELDS: {
      SUBSCRIPTION: {
        LABEL: "Subscription",
        NAME: "comboPlanId",
        PLACEHOLDER: "Select subscription plan",
      },
    },
  },
  FLEETS: {
    HEADER: "Create Fleets",
    FIELDS: {
      NAME: { LABEL: "Name", NAME: "name" },
      ORG_ID: {
        LABEL: "Organisation",
        NAME: "orgIds",
        PLACEHOLDER: "ORG Id",
      },
      VEHICLE_IMEI: {
        LABEL: "Vehicle IMEI",
        NAME: "vehicleImei",
        PLACEHOLDER: "Vehicle IMEI",
      },
      STATUS: {
        LABEL: "Status",
        NAME: "status",
        PLACEHOLDER: "Fleet Status",
      },
      DESCRIPTION: { LABEL: "Description", NAME: "description" },
    },
    VEHICLE:{
      HEADER: "Change the Fleet Vehicles",
      FIELDS: {
        IMEI: {
          LABEL: "IMEI",
          NAME: "imei",
          PLACEHOLDER: "IMEI Id",
        },
      }
    }
  },
  VEHICLE: {
    HEADER: "Create Vehicle",
    FIELDS: {
      IMEI: { LABEL: "IMEI", NAME: "imei" },
      ORG_ID: { LABEL: "Organisation", NAME: "orgIds", PLACEHOLDER: "Organisation", },
      MFR_ID: { LABEL: "Manufacturer", NAME: "manufacturer", PLACEHOLDER: "Manufacturer" },
      MFRDATE: { LABEL: "Manufacturer Date", NAME: "manufacturerDate" },
      NET_WEIGHT: { LABEL: "Net Weight", NAME: "netWeight" },
      COLOR: { LABEL: "Color", NAME: "color", PLACEHOLDER: "Select a color" },
      DEALERSHIP: { LABEL: "Dealership", NAME: "dealership", PLACEHOLDER: "Select a dealership" },
      OWNER: { LABEL: "Owner", NAME: "owner", PLACEHOLDER: "Select a owner" },
      MODEL: { LABEL: "Model", NAME: "Model", PLACEHOLDER: "Select a model" },
      CHASSIS: { LABEL: "Chassis", NAME: "chassis" },
      STATUS: { LABEL: "Status", NAME: "status", PLACEHOLDER: "Select a status" },
    },
  },
  VEHICLE_MODEL: {
    HEADER: "Create Vehicle Model",
    FIELDS: {
      NAME: { LABEL: "Name", NAME: "name" },
      GROSS_WEIGHT: { LABEL: "Gross Weight", NAME: "grossWeight" },
      NET_WEIGHT: { LABEL: "Net Weight", NAME: "netWeight" },
      WEIGHT_TYPE: { LABEL: "Weight Type", NAME: "weightType" },
      VARIANT: { LABEL: "Variant", NAME: "variant", PLACEHOLDER: "Variant", },
      DRIVE_MODE: { LABEL: "Drive Mode", NAME: "driveMode", PLACEHOLDER: "Drive Mode", },
    }
  },
  VALIDATION_ERRORS: {
    PHONE_NUMBER_VALID: "Please enter a valid phone number!",
    PHONE_NUMBER_DIGIT: "Please enter a 10-digit phone number.",
    POSTAL_CODE: "Postal Code must be a number!",
  },
};
